export default __webpack_public_path__ + "static/media/Furious Band.183d964f.jpg";